<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增消息
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="icon"
          slot-scope="text, record"
        >
          <img
            width="100"
            height="100"
            :src="record.icon"
            alt="图标"
          >
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            v-if="record.status_send===0"
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider
            v-if="record.status_send===0"
            type="vertical"
          />
          <a
            v-if="record.status===0"
            href="javascript:;"
            @click="() => onCheck(record)"
          >审核</a>
          <a-divider
            v-if="record.status===0"
            type="vertical"
          />
          <a
            v-if="record.status_send===0&&record.status===1"
            href="javascript:;"
            @click="() => onPublish(record)"
          >发布</a>
          <a-divider
            v-if="record.status_send===0&&record.status===1"
            type="vertical"
          />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <account-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :activity-visible="activityVisible"
      :title="title"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import AccountModal from './modal/index';
export default {
  components: { AccountModal },
  data() {
    return {
      btnIsLoading: false,
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      activityVisible: false,
      title: '',
      id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      page: String(this.current),
      pageSize: String(this.pageSize),
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/Message/getList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            title_sub: item.title_sub,
            title: item.title,
            type: item.type,
            qichacha_name: item.company.companyInfo? item.company.companyInfo.qichacha_name:'所有企业',
            status: item.status,
            status_send: item.status_send,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
        console.log('TCL: getTableData -> this.data', this.data);
      }
    },
    // 新增 编辑
    editAndAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.activityVisible=true;
      if (!record.id) {
        this.title = '新增活动';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.id=record.id;
        this.title = '编辑活动';
        console.log(this);
        this.$refs.formRef.changeCompanytype(String(record.type));
        let data={
          title_sub: record.title_sub,
          title: record.title,
          type: String(record.type),
          company_type: String(record.data.company_type),
          company_id: record.data.company.id?record.data.company.id:'0',
          jump_info: record.jump_info,
          summary: record.summary,
        };
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确认新增
    handleSubmit() {

      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('TCL: handleSubmit -> values', values);
          if (!err) {
            this.btnIsLoading=true;
            values.company_id=String(values.company_id);
            values.id=this.id?this.id:undefined;
            let result = await this.$http.post(
              '/Message/update',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.activityVisible = false;
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
              });
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.activityVisible = false;
    },

    // 审核
    async onCheck(record) {
      let result=await this.$http.post('/Message/setStatus', {id: record.id, status: '1'});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 发布
    async onPublish(record) {
      let result=await this.$http.post('/Message/send', {id: record.id});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/Message/setStatus', {id: record.id, status: '-1'});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
